import React from 'react';

import './Schallleistungspegel.css';

class Schallleistungspegel extends React.Component {
    constructor(props) {
    super(props);
    this.state = {
             daten: [],

    };
    }

    // daten = [];
    // datastring = '';
    getDaten(spaltgeschindigkeit){

        let Dname = this.getSpaltenname(spaltgeschindigkeit);

        let daten = this.state.daten;
        let Xname = 'Spalt'; //XName
        let Yname = 'Laenge'; //YName



        let xSoll1 = parseFloat(this.props.Kulissenspalt); //DS_Soll = Spaltbreite
        let ySoll1 = parseFloat(this.props.Kulissenlaenge); // KA_Soll = Kanallaenge
        let musskriterium1 = this.props.Kulissentyp; //Vorfilterung => Kulissentyp
        let musskriterium2 = parseFloat(this.props.Kulissenbreite); //Vorfilterung => Kulissendicke


        // //
        // console.log('xSoll1 ' + xSoll1);
        // console.log('ySoll1 ' + ySoll1);
        // console.log(daMin);
        // console.log("Kulissenspalt: "+ this.props.Kulissenspalt);

        let d = this.getDeltaWert(daten ,xSoll1,ySoll1,Xname,Yname,Dname,musskriterium1,musskriterium2);
        //this.props.KulissenpreisChange(d);
        return d;


    }

async componentDidMount(){
       // console.log('Daten-Schallleistungspegel:');
       //const request = await fetch('http://localhost:3000/schallleistungspegel.csv');
       const request = await fetch('../daten.csv');
       const datastring = await request.text();
       // console.log('Daten-Schallleistungspegel: ' + datastring.toString());
        let arr = datastring.split('\r');
        let jsonObj = [];
        let headers = arr[0].split(';');
        for(let i = 1; i < arr.length; i++) {
            let data = arr[i].split(';');
            let obj = {};

            for(let j = 0; j < data.length; j++) {
                obj[headers[j].trim()] = data[j].trim();
            }
            jsonObj.push(obj);
        }
        JSON.stringify(jsonObj);
        // console.log(jsonObj);
        //console.log("Nr.: "+jsonObj[0]["125"]);
        this.datastring = datastring;
        let daten = [];
        daten = await this.csvJSON(datastring);
        //this.daten = await this.csvJSON(datastring);
        // console.log("D:" + daten);
        // console.log(daten[0]["Typ"]);
        this.setState({daten : daten});
  }


  getDelta(x,y){
      let delta = x-y;
      return delta;
  }

  getMinTuple(daten,XSoll,YSoll,Xname,Yname, Muss1, Muss2){
  //Ermittelt den min-Wert eines Arrays von Tuple
  // min = Tupel mit X < XSoll && Y < YSoll jedoch Höchstwerte nahe XSoll & YSoll
  //     console.log(YSoll);
  //     console.log(Muss1);
       //let test = daten.filter((x) => x["Typ"] == Muss1 && x["Dicke"] == Muss2);
          let min = daten.filter((x) => String(x["Typ"]) === String(Muss1) && String(x["Dicke"]) === String(Muss2)).sort((a,b)=> a[Xname] - b[Xname] || a[Yname] - b[Yname]).find((x) => Math.min(x[Xname]) >=XSoll && Math.min(x[Yname]) >= YSoll);
      // console.log('min-Daten')
      // console.log(min);
      return min;
  }

  getMaxTuple(daten,XSoll,YSoll,Xname,Yname, Muss1, Muss2){
  //Ermittelt den max-Wert eines Arrays von Tuple
  // max = Tupel mit x > XSoll && Y > YSoll jedoch Niedrigwerte nahe XSoll & YSoll
  //     console.log("Xsoll getMax " + parseFloat(XSoll));
      let max = daten.filter((x) => String(x["Typ"]) === String(Muss1) && String(x["Dicke"]) === String(Muss2)).sort((a,b) => b[Yname] - a[Yname] || b[Xname] - a[Xname]).find((x) => Math.max(x[Xname]) <=XSoll && Math.max(x[Yname]) <= YSoll);
      // console.log('max-Daten')
      // console.log(max);
      return max;
  }


  getDeltaWert(daten ,xSoll, ySoll,Xname,Yname,Dname,musskriterium1,musskriterium2){
        //Interpoliert die Datensätze min/max
        //XSoll/YSoll ist der gesucht Wert der sich auf Xname/YName bezieht
        //Dname gibt den den zu Interpolierenden wert an.

        //min = Tupel mit X < XSoll && Y < YSoll jedoch Höchstwerte nahe XSoll & YSoll
        //max = Tupel mit x > XSoll && Y > YSoll jedoch Niedrigwerte nahe XSoll & YSoll
        // Xname = 'Spalt'
        // Yname = 'Laenge'
        // Dname = '250'
        // console.log('getWerte');
        // console.log("eingabendaten Detalwert");
        // console.log({xSoll});
        // console.log(ySoll);
        // console.log(Xname);
        // console.log(Yname);
        //console.log(Dname.toString());
      //
        let XSoll = parseFloat(xSoll);
        let YSoll = parseFloat(ySoll);

        // console.log({XSoll});


      //   console.log("Xsoll getMax " + parseFloat(XSoll));
       let min = this.getMinTuple(daten,XSoll,YSoll,Xname,Yname,musskriterium1,musskriterium2);
       let max = this.getMaxTuple(daten,XSoll,YSoll,Xname,Yname,musskriterium1,musskriterium2);
       if(min === undefined || max === undefined){
           // console.log("return 0 == undefined");
           return 0;

       }
       else {
           let deltaX = 0;
           let deltaXSoll = 0;
           let deltaY = 0;
           let deltaYSoll = 0;
           let deltaD = 0;
           let d1 = 0;
           let d = 0;

           // console.log(XSoll);
           // console.log(YSoll);
           // console.log(Xname);
           // console.log(Yname);
           // console.log(Dname);
           // if (min !== undefined) {
           //     console.log("min: " + min);
           // }
           // console.log('Länge: ');
           // console.log(min);

           deltaX = this.getDelta(parseFloat(max[Xname]), parseFloat(min[Xname]));
           // console.log('deltaX');
           // console.log(deltaX);

           deltaXSoll = this.getDelta(parseFloat(XSoll), parseFloat(min[Xname]));
           // console.log('deltaXSoll');
           // console.log(deltaXSoll);
           // console.log(isNaN(deltaXSoll));

           deltaY = this.getDelta(parseFloat(max[Yname]), parseFloat(min[Yname]));
           // console.log('deltaY');
           // console.log(deltaY);
           // console.log(isNaN(deltaY));
           deltaYSoll = this.getDelta(parseFloat(YSoll), parseFloat(min[Yname]));
           // console.log('deltaYSoll');
           // console.log(deltaYSoll);

           deltaD = parseFloat(max[Dname]) - parseFloat(min[Dname]);
           // console.log('max[' + Dname + ']');
           // console.log(max[Dname]);
           //
           // console.log('min[' + Dname + ']');
           // console.log(min[Dname]);
           //
           // console.log('deltaD');
           // console.log(deltaD);
           //
           // console.log((deltaXSoll / deltaX));

           d1 = parseFloat(min[Dname])
           // console.log('d1');
           // console.log(d1);
           //
           // console.log(isNaN(Math.pow((deltaXSoll / deltaX),2)));
           // if(isNaN(Math.pow((deltaXSoll / deltaX),2))){
           //     console.log("DeltaXSoll / deltaX is NaN");
           // }
           // if(isNaN(Math.pow((deltaYSoll / deltaY) ? 0 : (deltaXSoll / deltaX), 2))){
           //     console.log("DeltaYSoll / deltaY is NaN");
           // }
           //Wenn Delta d==0 dann nur d1 zurückgeben
           if(deltaD === 0){
               // console.log('d ' + Dname + ' hz: ' + d1);
               return d1; //
           }
           let deltaDIVX =0;
           if(isNaN((deltaXSoll / deltaX))){
               deltaDIVX = 0;
           }
           else {
               deltaDIVX = Math.pow((deltaXSoll / deltaX),2);
           }

           let deltaDIVY =0;
           if(isNaN((deltaYSoll / deltaY))){
               deltaDIVY = 0;
           }
           else {
               deltaDIVY = Math.pow((deltaYSoll / deltaY),2);
           }

            let calc = Math.sqrt( deltaDIVX + deltaDIVY);
           //d = d1 + deltaD * Math.sqrt((Math.pow( (deltaXSoll / deltaX)  ? 0 : (deltaXSoll / deltaX), 2) + Math.pow((deltaYSoll / deltaY) ? 0 : (deltaXSoll / deltaX), 2)));
            d = d1 + deltaD * calc;

           // console.log('d ' + Dname + ' hz: ' + d);
           //console.log(d);

           return d;
       }
  }

  csvJSON(csv){
        let arr = csv.split('\r');
        let jsonObj = [];
        let headers = arr[0].split(';');
        for(let i = 1; i < arr.length; i++) {
            let data = arr[i].split(';');
            let obj = {};

            for(let j = 0; j < data.length; j++) {
                obj[headers[j].trim()] = data[j].trim();
            }
            jsonObj.push(obj);
        }
        JSON.stringify(jsonObj);
        return jsonObj;
}
  getSpaltenname(spaltgeschwindigkeit){
        //Ermittelt anhand der effektiven Spaltgeschwindigkeit die benötigte Spalte in der CSV Datei
        if(spaltgeschwindigkeit <=2){
            return "2"
        }
        else if( spaltgeschwindigkeit>2 && spaltgeschwindigkeit <=4)
        {
            return "4";
        }
        else if(spaltgeschwindigkeit >4 && spaltgeschwindigkeit<=6)
        {
            return "6";
        }
        else if( spaltgeschwindigkeit >6 && spaltgeschwindigkeit<=8)
        {
            return "8";
        }
        else if( spaltgeschwindigkeit >8 && spaltgeschwindigkeit<=10)
        {
            return "10";
        }
        else if( spaltgeschwindigkeit >10 && spaltgeschwindigkeit<=13)
        {
            return "13";
        }
        else if( spaltgeschwindigkeit >13 && spaltgeschwindigkeit<=16)
        {
            return "16";
        }
        else if( spaltgeschwindigkeit >16 && spaltgeschwindigkeit<=18)
        {
            return "18";
        }
        else if( spaltgeschwindigkeit >18)
        {
            return "20";
        }

   }



  render() {
        // console.log("Datenlänge: "+this.state.daten.length);

      return <>{this.getDaten(this.props.Kulissenspaltgeschwindigkeit).toFixed(2)}</>;

    // return (
    //     <>
    //          {/*<td>{this.getDeltaWert(this.props.Einfuegedaempfungsdaten ,xSoll,ySoll,Xname,Yname,'250')}</td>*/}
    //         {/*<td>{this.getDaten("Preis").toFixed(2)}</td>*/}
    //         {/* <td>{this.getDaten("63").toFixed(2)}</td>*/}
    //         {/*<td>{this.getDaten("125").toFixed(2)}</td>*/}
    //         {/*<td>{this.getDaten("250").toFixed(2)}</td>*/}
    //         {/*<td>{this.getDaten("500").toFixed(2)}</td>*/}
    //         {/*<td>{this.getDaten("1000").toFixed(2)}</td>*/}
    //         {/*<td>{this.getDaten("2000").toFixed(2)}</td>*/}
    //         {/*<td>{this.getDaten("4000").toFixed(2)}</td>*/}
    //         {/*<td>{this.getDaten("8000").toFixed(2)}</td>*/}
    //
    //     </>);


  }
}
export default Schallleistungspegel;
